export default {
  NotifyMessage: {
    AppName: 'EMIS Ôn tập',
    Warning: 'Cảnh báo',
    Notification: 'Thông báo',
    ConfirmChangeTitle: 'Lưu thay đổi',
    DeleteSuccess: 'Bạn đã xóa thành công',
    StopShare: 'Ngừng chia sẻ học liệu thành công',
    StopExamShare: 'Ngừng chia sẻ bài thi thành công',
    ErrorOccurred: 'Đã có lỗi xảy ra.',
    NoneRecordsSelected: 'Bạn chưa chọn bản ghi nào.',
    ConfirmDelete: 'Bạn có chắc là xóa {entityName} không?',
    ConfirmDeleteMultiple: 'Bạn có chắc là xóa các {entityName} đã chọn?',
    SavedSuccess: 'Bạn đã lưu thành công.',
    ConfirmChanged: 'Bạn có muốn lưu trước khi rời đi không?',
    CopyToClipboardSuccess: 'Đã sao chép mã lớp',
    CopyNoteToClipboard: 'Ghi chú đã được sao chép vào bộ nhớ tạm thời!',
    MessageSubmitted: 'Đã nộp bài',
    MessageCompleted: 'Đã hoàn thành bài',
    SaveDraftSuccess: 'Đã lưu nháp',
    ExerciseSaved: 'Bài tập đã được lưu vào Kho học liệu cá nhân.',
    AssignmentNow: 'Bạn có muốn Giao bài tập ngay?',
    AssignSuccess: 'Bạn đã giao bài thành công',
    UpdateSuccess: 'Bạn đã cập nhật thành công',
    ConfirmSaveDraft: 'Bạn có muốn lưu nháp không?',
    SaveFavoriteSuccess: 'Đã thêm vào yêu thích',
    CancelFavorite: 'Đã bỏ yêu thích',
    MessageDeleteExercise: 'Bạn có chắc Xóa bài tập khỏi danh sách bài đã giao lớp <br><b>{className}</b> ?',
    DidNotChoseCorrectAnswerMessage: '<div>Bạn vui lòng chọn đáp án đúng cho <b>{questions}</b></div>',
    DidNotFillAnswerContentMessage: '<div>Bạn vui lòng nhập nội dung đáp án cho <b>{questions}</b></div>',
    DidNotFillQuestionContentMessage: '<div>Bạn vui lòng nhập nội dung câu hỏi cho <b>{questions}</b></div>',
    DidNotFillParentQuestionContentMessage: '<div>Bạn vui lòng nhập nội dung câu hỏi cho <b>{questions}</b></div>',
    DidNotMappingAnswer: '<div>Bạn vui lòng nối đáp án cho <b>{questions}</b></div>',
    UnfolowClassroomMessage: 'Đã ngừng theo dõi lớp <b>{entity}</b>',
    LeaveClassroomMeassage: 'Đã rời khỏi lớp <b>{entity}</b>',
    JoinClassSuccess: 'Tham gia lớp học thành công',
    SharedExercise: 'Đã chia sẻ thành công {countExercise} học liệu',
    ShareSuccess: 'Đã chia sẻ thành công',
    MessageSaveSuccessAfterDeadline: 'Bài tập đã được nộp. <br> Kết quả sẽ được nhận vào {timeDeadline} - {dateDeadline}.',
    MessageSaveSuccessShowResult: 'Bài tập đã được nộp. <br> Hãy xem kết quả bài làm của bạn bên dưới.',
    MessageCompletedAfterDeadline: 'Bài tập đã được hoàn thành. <br> Kết quả sẽ được nhận vào {timeDeadline} - {dateDeadline}.',
    MessageCompletedShowResult: 'Bài tập đã được hoàn thành. <br> Hãy xem kết quả bài làm của bạn bên dưới.',
    GetExerciseStore: 'Lấy về kho học liệu thành công',
    GetSuccessCollect: 'Đã lưu về kho cá nhân',
    SubmitCommentsSuccess: 'Đã khảo sát thành công',
    CorrectingNotDone: 'Còn <b>{count}</b> học sinh chưa được chữa bài',
    ChooseExerciseShareNotYet: 'Bạn chưa chọn bài tập nào để chia sẻ',
    EndOfTime: 'Đã hết giờ làm bài',
    YouCanNotLeaveScreen: 'Bạn không được rời khỏi màn hình trong thời gian làm bài',
    HasErrorTryAgain: 'Có lỗi xảy ra, vui lòng thử lại!',
    MessageDeleteExamPeriod: 'Bạn có chắc xóa <b>{examInformationTitle}</b>?',
    MessageSaveSuccessExam: 'Đã thêm bài kiểm tra thành công',
    MessageErrorSaveExam: 'Bạn chưa chọn học sinh. Vui lòng chọn học sinh',
    MessageUpdateSuccessExam: 'Đã cập nhật bài kiểm tra thành công',
    MessageOpenTopicExamPeriod: 'Học sinh có thể tiến hành vào làm bài sau khi đề đã mở.',
    MessageCloseTopicExamPeriod: 'Sau khi đóng đề học sinh không thể làm bài',
    MessageSendMarkExamPeriod: 'Bạn có chắc muốn gửi điểm không?',
    MessageRecallMarkExamPeriod: 'Bạn có chắc muốn thu hồi điểm không?',
    ComfirmSubmitExam: 'Còn <b>{0}/{1}</b> câu chưa làm. Bạn có chắc muốn nộp bài không?',
    ExamIsOver: 'Bài kiểm tra đã kết thúc.',
    ExamNotOpen: 'Bài kiểm tra chưa được mở.',
    MessageErrorDatetime: 'Thời gian đóng đề phải lớn hơn thời gian làm bài',
    ConfirmSubmitExam: 'Bạn có thực sự muốn nộp bài?',
    SaveSuccess: 'Lưu thành công',
    SaveAndView: 'Bạn cần lưu thông tin trước khi xem Chi tiết',
    CopySuccess: 'Sao chép thành công',
    DoNotEmptyFile: 'Bạn chưa có bài làm',
    DoNotExamStatistic: 'Bạn chưa chọn lớp học',
    MessageOpenTopicSchoolExamPeriodOverview: 'Bạn có chắc muốn mở đề cho bài kiểm tra {ListExamPeriod} không?',
    ResetSuccessful: 'Bạn đã hủy thành công',
    WarningOrientation: 'Bạn phải quay ngang màn hình để ứng dụng được hiển thị đẹp nhất',
    WarningUseOTPRO: 'Nhà trường chưa đăng ký dịch vụ này',
    ExerciseSavedAssignNow: 'Đã lưu bài vào kho Học liệu <br> Bạn có muốn Giao bài tập ngay?',
    ContinueExercise: 'Bạn có muốn tiếp tục làm bài tập không?',
    WaringDownload: 'Phiếu bài tập có chứa nội dung âm thanh và video. Chỉ tải xuống nội dung câu hỏi?',
    FileNotFound: 'Không tìm thấy file',
    ResetPassword: 'Đặt lại về mật khẩu mặc định: <b>12345678</b>',
    TitleResetPassword: 'Đổi lại mật khẩu',
    SendInformationSuccess: 'Gửi thông tin thành công',
    ConfirmChangeExerciseType: 'Nội dung đã soạn sẽ bị xóa hết khi đổi kiểu soạn. Bạn có muốn đổi không?',
    ConfirmChoseImportData: 'Nội dung đã soạn sẽ bị làm mới sau khi sử dụng tính năng Nhập khẩu/Tách câu tự động. Bạn có muốn tiếp tục không?',
    WarningCreateCalendar: 'Bạn không thể tạo lịch học trong quá khứ',
    PleaseChooseImage: 'Vui lòng chọn 1 ảnh',
    TryAgainOrChooseAnotherImage: 'Có lỗi xảy ra. Vui lòng thử lại hoặc chọn ảnh khác!',
    GoogleDriveNotEnoughMemory: 'Bộ nhớ lưu trữ video của trường đã hết.<br>Vui lòng liên hệ cán bộ của trường để được trợ giúp.',
    HasErrorUploadFile: 'Có lỗi xảy ra khi tải file',
    ViewDetail: '<br><span class="text-accent-200">Xem chi tiết</span>',
    JoinNow: '<p class="text-accent-200 underline">Tham gia ngay</p>',
    RegisterCourseFailed: 'Đăng ký khóa học không thành công',
    ChooseRelatedCourse: 'Hãy chọn khóa học đính kèm khi bạn đã chọn mua combo',
    SchoolHasNotLinkedGoogleDrive: 'Nhà trường cần liên kết với tài khoản Google Drive để có thể tải lên file video. Vui lòng liên hệ MISA để được trợ giúp.',
    FileExtensionInvalid: 'Định dạng file không đúng.',
    StartTimeLessThanEndTime: 'Bạn phải chọn ngày mở đề nhỏ hơn ngày đóng đề.',
    ReceiveStartCourseFeedback: 'Chúc mừng bạn đã được tặng {star} sao học tập!',
  }
}
